import React from 'react';
import { Typography, TypographyProps } from '@talentmesh/core';

const Body2Typography: React.FC<TypographyProps> = (props) => {
    return <Typography {...props} variant="body2" />;
};
export default Body2Typography;
